import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';

import api from '../api';
import { Provider as name } from '../config';
import { useGet, useGetById, usePost, usePut, useRemove } from '../../apiHooks';
import { PaymentGateway } from '../model';

import Context from './context';

interface Props {
    children: React.ReactElement;
}

const PaymentGatewayProvider = (props: Props) => {
    const { children } = props;
    const [data, setData] = useState<PaymentGateway[]>([]);
    const [selected, setSelected] = useState<PaymentGateway | null>(null);
    const [, setError] = useState<Error>();

    const getById = useGetById(api, selected, setSelected, setError);

    const handleGetData = useCallback((res) => {
        setData(res);
        return res;
    }, []);
    const get = useGet(api, data, handleGetData, setError);

    const handleSetData = useCallback((item, newData) => {
        setData(newData);
    }, []);
    const post = usePost(api, data, handleSetData, setError);

    const handlePutCallback = useCallback((response, newData) => {
        setData(newData);
        setSelected(response);
    }, []);
    const put = usePut(api, data, handlePutCallback, setError);

    const handleDeleteCallback = useCallback((id, newData) => {
        setData(newData);
        setSelected(null);
        return id;
    }, []);
    const remove = useRemove(api, data, handleDeleteCallback, setError);

    return (
        <Context.Provider
            value={{
                name,
                get,
                getById,
                post,
                put,
                data,
                setData,
                selected,
                setSelected,
                remove
            }}
        >
            {children}
        </Context.Provider>
    );
};

PaymentGatewayProvider.propTypes = {
    children: PropTypes.element.isRequired
};

export default PaymentGatewayProvider;
